"use strict"

$(document).on("turbolinks:load", function() {
  activate_footer_agreements()
})

function activate_footer_agreements() {
  $('#footer_agreement').on('click', '.footer_agreement-closer,.footer_agreement-ok', function(event) {
    $.cookie('agreement', 'true', {path: '/', expires: 180})
    $('#footer_agreement').remove()
  })
  if ($.cookie('agreement')==='true') {
    $('#footer_agreement').remove()
  }
}
